<template>
    <v-form-element :id="id" :label="label" :form="form" :input-name="inputName" :with-counter="withCounter" :max-length="maxLength" :container-class-name="containerClassName" :label-container-class-name="labelContainerClassName" :input-container-class-name="inputContainerClassName" :helper="helper" v-click-outside="hidePicker">
        <div class="relative">
            <input
                :id="id"
                :type="type"
                :class="className"
                :placeholder="getPlaceholder()"
                v-model="model"
                :required="required"
                :disabled="disabled"
                @focus="showPicker"
                @blur="$emit('blur')"
                @click="$emit('click')"
                @hover="$emit('hover')"
            />
            <span class="absolute center-y right-0 pr-2" v-if="displayed">
                <img src="/icons/close.svg" class="h-3 w-3 opacity-25 cursor-pointer" @click="displayed = false" />
            </span>
        </div>
        <color-picker :value="model" @input="updateValue" v-show="displayed"></color-picker>
    </v-form-element>
</template>

<script>

    import FormElement from './Element';
    import mixin from './mixin';
    import { Chrome } from 'vue-color'


    export default {
        components: {
            'v-form-element': FormElement,
            'color-picker': Chrome
        },
        mixins: [mixin],
        data() {
            return {
                displayed: false
            }
        },
        methods: {
            hidePicker(event) {
                this.displayed = false;
            },
            showPicker() {
                this.$nextTick(() => {
                    this.displayed = true;
                });

                this.$emit('focus');
            },
            updateValue(foo) {
                this.model = foo.hex;
            }
        }
    }
</script>
